/* eslint-disable camelcase, max-len  */
const {
  getFullDate
} = require(`../../../utils/date`);
const COMMERCE_CATEGORIES = [{
  id: 'fashion',
  name: 'Fashion',
  link: 'fashion',
  origin: 'fil-fa',
  weaver_feed: 'shopping-categories-fashion',
  laser_tag: 'fashion',
  products_tag: 'Fashion',
  images: {
    desktop: 'fashion_desktop.png',
    mobile: 'fashion_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/fOpA0nj-6.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/9xbbjLP9Ey.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/1Te5gRKnR.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e36n5B8Uu.png'
  },
  order: 2,
  meta: {
    name: `Biggest Fashion Deals for ${getFullDate()}`,
    description: 'A curated list of the best articles featuring the latest deals on jeans, tops, dresses, shoes and underwear at the cheapest prices.'
  },
  bg_color: '#323254',
  text_color: '#FFFFFF'
}, {
  id: 'home',
  name: 'Home',
  link: 'home',
  origin: 'fil-ho',
  laser_tag: 'home',
  products_tag: 'Home',
  weaver_feed: 'shopping-categories-home',
  images: {
    desktop: 'home_desktop.png',
    mobile: 'home_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NRGqnQAer.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/6G8s_R7QP.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/YL6sfQ9kT.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/hyCaolCh3.png'
  },
  order: 3,
  meta: {
    name: `Home Decor Deals for ${getFullDate()}`,
    description: 'Home Organization, decor, and design deals brought to you by the curators at BuzzFeed like live and love this stuff.'
  },
  bg_color: '#FFE3D4',
  text_color: '#222222'
}, {
  id: 'beauty-personal-care',
  name: 'Beauty + Personal Care',
  link: 'beauty-personal-care',
  origin: 'fil-be',
  laser_tag: 'beauty_personal_care',
  products_tag: 'Beauty & Personal Care',
  weaver_feed: 'shopping-categories-beauty-personal-care',
  images: {
    desktop: 'beauty_desktop.png',
    mobile: 'beauty_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NMBw4k8RH.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/yt1cLM0Nb.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Bvh8slOTU.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/BHJXqrzPJ.png'
  },
  order: 1,
  meta: {
    name: `Beauty and Personal Care Deals For ${getFullDate()}`,
    description: 'A curated list of the best articles on Beauty and Personal Care deals including skin care, acne treatments, lip gloss, teeth whiteners and more.'
  },
  bg_color: '#587E6F',
  text_color: '#FFFFFF'
}, {
  id: 'amazon',
  name: 'Amazon UK',
  link: 'amazon',
  origin: 'fil-am',
  laser_tag: 'amazon',
  products_tag: 'Amazon',
  weaver_feed: 'shopping-categories-amazon',
  images: {
    desktop: 'stores_amazon_desktop.png',
    mobile: 'stores_amazon_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/D24l-49of.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/g3puQLWvg.png',
    discover: {
      1: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/XCtAkU_Ff.png',
      2: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/RPySguYva.png',
      3: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/m222jKGUP.png',
      4: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/EnZf4cLBv.png'
    }
  },
  order: 5,
  meta: {
    name: 'Best Brands to buy Everything',
    description: 'We have curated a list of articles to find the best brand deals to find what you\'re looking, all in one place.'
  },
  bg_color: '#FF9C9F',
  text_color: '#222222'
}];
module.exports = {
  COMMERCE_CATEGORIES
};
